import { useEffect, useState } from 'react';

const FALLBACK_ASPECT = 16 / 9;

/**
 * Real width:height of the whole assembled artwork, measured from one tile image
 * (tile aspect x cols / rows). Admin images can be any size or shape, so nothing
 * downstream may assume 1920x1080. Returns the fallback until the tile has loaded.
 */
export default function useBoardAspectRatio(firstTileUrl, macroRows, macroCols) {
  const [tileAspect, setTileAspect] = useState(null);

  useEffect(() => {
    setTileAspect(null);
    if (!firstTileUrl) return undefined;
    let cancelled = false;
    const img = new Image();
    img.onload = () => {
      if (cancelled || !img.naturalWidth || !img.naturalHeight) return;
      setTileAspect(img.naturalWidth / img.naturalHeight);
    };
    img.src = firstTileUrl;
    return () => {
      cancelled = true;
    };
  }, [firstTileUrl]);

  return tileAspect && macroRows > 0 ? (tileAspect * macroCols) / macroRows : FALLBACK_ASPECT;
}
